import React from "react";

import { URI_PATHS } from "../../../constants";
import {
  DECISION_APPROVED,
  DECISION_ERROR,
  DECISION_PENDING,
  DECISION_REJECTED,
} from "./constants";

import InitialSubmissionScreen from "./InitialSubmissionScreen";
import DecisionError from "./DecisionError";
import DecisionPending from "./DecisionPending";
import DecisionRejected from "./DecisionRejected";

const DetermineScreen = ({ decisionStatus }) => {

  let ComponentToShow;
  switch(decisionStatus){
    case DECISION_PENDING:
      ComponentToShow = <DecisionPending />;
      break;
    case DECISION_REJECTED:
      ComponentToShow = <DecisionRejected />;
      break;
    case DECISION_ERROR:
      ComponentToShow = <DecisionError />;
      break;
    default:
      ComponentToShow = <InitialSubmissionScreen />;
      break;
  }

  if(decisionStatus === DECISION_APPROVED){
    // Not able to override basename in react-router-dom v5.0.1 so
    // we'll have to resort using native javascript for redirects outside
    // of onboarding
    window.location.pathname = URI_PATHS.DASHBOARD;
    return null;
  }

  return ComponentToShow;
};

export default DetermineScreen;
